import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Icon = ({className, icon, type, style = {}, ...props}) => (
    <span className={classNames('icon', `icon-ic_${icon}`, type, className)} style={style} {...props} />
);

Icon.propTypes = {
    className: PropTypes.string,
    icon: PropTypes.string.isRequired,
    type: PropTypes.string,
    style: PropTypes.object,
};

export default Icon;
